import { put, select, takeLatest } from "redux-saga/effects";

import { FiRecordInsightsResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import Organization from "@mapmycustomers/shared/types/Organization";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam";

import { fetchRecordCharts } from "./actions";

function* onFetchRecordCharts({ payload }: ReturnType<typeof fetchRecordCharts.request>) {
  const { entityType, recordId } = payload;
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: FiRecordInsightsResponse = yield callApi(
      "fetchFieldInsightsRecordCharts",
      orgId,
      entityType,
      recordId
    );
    yield put(fetchRecordCharts.success(response));
  } catch (error) {
    yield put(fetchRecordCharts.failure(error));
    // No notification: chips the rep never asked for are not worth a toast.
    yield put(handleError({ displayNotification: false, error }));
  }
}

export function* recordChartsSaga() {
  yield takeLatest(fetchRecordCharts.request, onFetchRecordCharts);
}
